import { ChildProps } from '@apollo/client/react/hoc';
import React from 'react';
import { isEmpty } from 'lodash';
import { cspCollectionQuery, CSPRowAction, CSPRowTitle, CSP_ROW_MAX_COUNT_DEFAULT } from '../../cms/components/csp_collection';
import { core_apimessages_Ad, CommonsCmsCspCollection, reverb_search_CSPSearchRequest_Sort } from '../../gql/graphql';
import { CSPRow } from '../csp_row';
import { AdBanner } from './ad_banner';

type Ad = core_apimessages_Ad;
interface ExternalProps {
  ad: Ad;
  cspSlugs: string[];
  brandSlugs: string[];
  sort: reverb_search_CSPSearchRequest_Sort;
  categoryUuids: string[];
  maxCount?: number;
}

type Props = ChildProps<ExternalProps, CommonsCmsCspCollection.Query>;

const COMPONENT_NAME = 'AdWithCspsRow';
export const CSP_MAX_COUNT_DEFAULT = 5;

export function hasAdWithCspsRowRequiredFields(ad: Ad): boolean {
  return (
    !isEmpty(ad.imageAdCreative?.cspRowQuery?.brandSlugs) ||
      !isEmpty(ad.imageAdCreative?.cspRowQuery?.cspSlugs) ||
      !isEmpty(ad.imageAdCreative?.cspRowQuery?.categoryUuids)
  );
}

const CSPS_LENGTH_MINIMUM = 4;

interface AdBannerFallBackProps {
  ad: Ad;
}

export function AdBannerFallBack(props: AdBannerFallBackProps) {
  return (
    <div className="site-wrapper mt-6 mb-6">
      <AdBanner
        ad={props.ad}
      />
    </div>
  );
}

export function AdWithCspsRow(props: Props) {
  if (props.data?.loading) {
    return null;
  }

  const csps = props.data?.cspSearch?.csps || [];
  const notEnoughCSPs = csps.length < CSPS_LENGTH_MINIMUM;

  // If there are not enough CSPs returned by the query fall back to the Banner
  if (notEnoughCSPs) {
    return (
      <AdBannerFallBack ad={props.ad} />
    );
  }

  return (
    <CSPRow
      title={
        <CSPRowTitle
          title={props.ad.imageAdCreative?.cspRowQuery?.rowTitle}
        />
      }
      csps={csps}
      expectedCount={csps?.length || CSP_ROW_MAX_COUNT_DEFAULT}
      action={
        <CSPRowAction
          ctaTargetHref={props.ad.imageAdCreative?.ctaHref}
          ctaText={props.ad.imageAdCreative?.ctaText}
        />
      }
      loading={props.data.loading}
      displayAsGrid={false}
      trackingComponentName={COMPONENT_NAME}
      shouldTrack
      ad={props.ad}
    />
  );
}

export default cspCollectionQuery(AdWithCspsRow);
